import { toolboxApi, unwrapResult, type ApiEnvelope } from '~/modules/query/base';

export interface DecouplingAgent {
  [key: string]: unknown;
  publicId?: string;
  listingAgentsByMls?: Record<
    string,
    { id: string; isSelected?: boolean; [key: string]: unknown }[]
  >;
}

export interface DecouplingMls {
  [key: string]: unknown;
  description?: string;
}

/** GET /customerIntegration/decoupling/machines/NEW */
export interface DecouplingWizardData {
  [key: string]: unknown;
  agents?: DecouplingAgent[];
  mlss?: DecouplingMls[];
}

/** POST /customerIntegration/decoupling/machines body. */
export interface DecoupleRequest {
  customerMoniker: string;
  agents?: DecouplingAgent[];
  mlss?: DecouplingMls[];
  mapListings?: boolean;
  pushPasswords?: boolean;
}

export const decouplingApi = toolboxApi.injectEndpoints({
  endpoints: (builder) => ({
    getWizardData: builder.query<
      DecouplingWizardData,
      { customerMoniker: string; reachbackYears?: number }
    >({
      query: ({ customerMoniker, reachbackYears = 1 }) => ({
        url: '/customerIntegration/decoupling/machines/NEW',
        method: 'GET',
        params: { customerMoniker, reachback: JSON.stringify({ years: reachbackYears }) },
      }),
      transformResponse: unwrapResult<DecouplingWizardData>,
    }),

    // Keeps sysbay's envelope: the wizard only checks whether the call succeeded.
    decouple: builder.mutation<ApiEnvelope<unknown>, DecoupleRequest>({
      query: (body) => ({
        url: '/customerIntegration/decoupling/machines',
        method: 'POST',
        data: body,
        timeout: 600000,
      }),
      invalidatesTags: ['Customer', 'CustomerAgents'],
    }),
  }),
});

export const { useGetWizardDataQuery, useDecoupleMutation } = decouplingApi;
